export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_SINGLE_PRODUCT = "SET_SINGLE_PRODUCT";
export const SET_CATEGORY = "SET_CATEGORY";
